import React from 'react'
import { FullWidthCard, PictureCardWithInteriorBorder, PictureCards } from '../cards'
import { CardHeader, BigParagraph } from '../../typography'
import * as styles from './our-impact.module.css'
import * as colors from '../../colors.module.css'
import { ArrowLinkRow } from '../arrow-link'
import { StaticImage } from 'gatsby-plugin-image'

function StudentsIcon({ color }) {
  return (
    <svg
      className={styles.icon}
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9499 0C15.5815 0 11.1733 4.40822 11.1733 9.77664C11.1733 15.1451 15.5815 19.5533 20.9499 19.5533C26.3184 19.5533 30.7266 15.1451 30.7266 9.77664C30.7266 4.40822 26.3184 0 20.9499 0ZM20.9499 5.58665C23.2959 5.58665 25.1399 7.43068 25.1399 9.77664C25.1399 12.1226 23.2959 13.9666 20.9499 13.9666C18.604 13.9666 16.7599 12.1226 16.7599 9.77664C16.7599 7.43068 18.604 5.58665 20.9499 5.58665ZM50.2798 8.37997C45.6861 8.37997 41.8999 12.1662 41.8999 16.7599C41.8999 21.3537 45.6861 25.1399 50.2798 25.1399C54.8736 25.1399 58.6598 21.3537 58.6598 16.7599C58.6598 12.1662 54.8736 8.37997 50.2798 8.37997ZM50.2798 13.9666C51.8511 13.9666 53.0732 15.1887 53.0732 16.7599C53.0732 18.3312 51.8511 19.5533 50.2798 19.5533C48.7086 19.5533 47.4865 18.3312 47.4865 16.7599C47.4865 15.1887 48.7086 13.9666 50.2798 13.9666ZM9.60205 19.6406C7.0706 19.6078 4.67009 21.31 4.0154 23.8306L1.0475 35.353C0.30552 38.2227 1.96406 41.2015 4.80103 42.0745L9.86393 43.6457C10.0276 44.4095 10.3549 45.0969 10.8241 45.7407L26.2747 67.0398H39.6303L43.9949 61.0167L44.4313 59.3582L40.2413 53.1605L38.8447 58.5725L32.9089 66.7779L15.3633 42.4236L18.6804 27.2349L19.9024 27.4968L22.0847 34.9166C22.5757 36.5969 23.8415 37.9608 25.4891 38.5828L31.5122 40.8524C30.8357 43.6348 32.4506 46.4827 35.1784 47.3992L42.5109 49.9307L54.9936 67.0398H61.8896L46.0899 45.2169L48.8832 32.647L50.629 33.0834L52.8113 40.5032C53.3023 42.1836 54.568 43.5475 56.2157 44.1694L66.0796 47.923L68 42.6855L58.1361 39.0193V38.932L56.0411 31.5122C55.4846 29.5809 53.8915 28.1406 51.9384 27.6714L41.2888 25.1399C38.3646 24.4416 35.3312 26.242 34.5674 29.1553L32.9089 35.4403L27.4095 33.3453L25.3145 26.0128C24.7471 24.0597 23.1213 22.5212 21.1245 22.0847L10.6496 19.7279C10.2895 19.6515 9.96213 19.6406 9.60205 19.6406ZM9.42747 25.2272L13.181 26.0128L10.5623 38.059L6.45956 36.7497C6.43774 36.7388 6.36136 36.7824 6.37227 36.7497L9.42747 25.2272ZM39.9795 30.552L43.3838 31.3376L40.7651 43.4711L36.9243 42.1617L39.9795 30.552ZM9.51476 50.3671L8.1181 55.7792L0 67.0398H6.89602L13.2683 58.2234L13.7047 56.5648L9.51476 50.3671Z"
        fill={color}
      />
    </svg>
  );
}

function SchoolsIcon({ color }) {
  return (
    <svg
      className={styles.icon}
      width="68"
      height="71"
      viewBox="0 0 68 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.7283 0.520752L0 10.7214L1.88269 17.0444L33.7283 7.42443L65.574 17.0444L67.4567 10.7214L33.7283 0.520752ZM0.941346 23.7933V60.1311C23.8922 60.1311 33.7283 70.0415 33.7283 70.0415C33.7283 70.0415 43.5644 60.1311 66.5154 60.1311V23.7933C43.5644 23.7933 33.7283 33.7036 33.7283 33.7036C33.7283 33.7036 23.8922 23.7933 0.941346 23.7933ZM7.49875 30.7098C22.3611 32.1468 28.8462 38.1436 29.0921 38.3749L30.4496 39.7814V60.0408C25.3903 57.4131 17.9142 54.6421 7.49875 53.7888V30.7098ZM59.9579 30.7098V53.7888C49.5425 54.6421 42.0664 57.4131 37.007 60.0408V39.7427L38.3006 38.4394C38.6055 38.152 45.0923 32.1468 59.9579 30.7098Z"
        fill={color}
      />
    </svg>
  );
}

function OnlineIcon({ color }) {
  return (
    <svg
      className={styles.icon}
      width="76"
      height="73"
      viewBox="0 0 76 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="66.4097"
        cy="47.1458"
        r="5.82986"
        stroke={color}
        strokeWidth="6.59028"
      />
      <circle
        cx="9.125"
        cy="47.6528"
        r="5.82986"
        stroke={color}
        strokeWidth="6.59028"
      />
      <line
        x1="13.5607"
        y1="46.4791"
        x2="23.4947"
        y2="40.7437"
        stroke={color}
        strokeWidth="6.59028"
      />
      <line
        x1="37.2605"
        y1="57.0959"
        x2="37.2605"
        y2="45.6251"
        stroke={color}
        strokeWidth="6.59028"
      />
      <circle
        cx="37.5139"
        cy="63.875"
        r="5.82986"
        stroke={color}
        strokeWidth="6.59028"
      />
      <circle
        cx="9.125"
        cy="15.7153"
        r="5.82986"
        stroke={color}
        strokeWidth="6.59028"
      />
      <line
        x1="14.3212"
        y1="18.4381"
        x2="24.2552"
        y2="24.1735"
        stroke={color}
        strokeWidth="6.59028"
      />
      <line
        x1="52.849"
        y1="39.7296"
        x2="62.783"
        y2="45.465"
        stroke={color}
        strokeWidth="6.59028"
      />
      <circle
        cx="38.0209"
        cy="32.4445"
        r="14.4479"
        stroke={color}
        strokeWidth="6.59028"
      />
      <line
        x1="48.3643"
        y1="20.4825"
        x2="56.4754"
        y2="12.3714"
        stroke={color}
        strokeWidth="6.59028"
      />
      <circle
        cx="60.3264"
        cy="9.125"
        r="5.82986"
        stroke={color}
        strokeWidth="6.59028"
      />
    </svg>
  );
}

function OurImpactCard({ img, color, Icon, figure, description }) {
  return (
    <PictureCardWithInteriorBorder
      img={img}
      color={color}
      contentsClassName={styles.contents}
    >
      <Icon color={color} />
      <p className={styles.figure} style={{ color }}>
        {figure}
      </p>
      <p>{description}</p>
    </PictureCardWithInteriorBorder>
  );
}

function OurImpactCards() {
  return (
    <PictureCards>
      <OurImpactCard
        img={<StaticImage src="../../images/boy-set-shot.png" alt="" />}
        color="#ef4b40"
        Icon={StudentsIcon}
        figure="50,000"
        description="students educated through our team sports programs"
      />
      <OurImpactCard
        img={<StaticImage src="../../images/kids-jumping-basketball-court-584px.png" alt="" />}
        color="#282862"
        Icon={SchoolsIcon}
        figure="100"
        description="schools empowered with access to coaches, supplies, and facilities"
      />
      <OurImpactCard
        img={<StaticImage src="../../images/joining-hands.png" alt="" />}
        color="#F8BE20"
        Icon={OnlineIcon}
        figure="3,000,000"
        description="youth engaged in our online fitness community"
      />
    </PictureCards>
  );
}

const OurImpact = React.forwardRef((props, ref) => (
  <FullWidthCard className={styles.ourImpactSection} ref={ref}>
    <CardHeader className={colors.navy}>Our Impact</CardHeader>
    <OurImpactCards />
    <ArrowLinkRow
      text="Learn more about what we do"
      to="/what-we-do"
      color="#282862"
    />
  </FullWidthCard>
))

export default OurImpact;
